'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function HomeController($document, $filter, $state, $scope, CityComponent, SubLineComponent, Toast, $timeout, $rootScope) {
	'ngInject';

	var vm = this;
	var rightAside = angular.element(document.getElementById('rightAside'));
	var publicPage = angular.element(document.getElementById('publicParrent'));

	// --------------------------------------------------/
	vm.searchResult = searchResult;
	vm.clearResults = clearResults;
	vm.swapResult = swapResult;
	vm.searchCities = CityComponent.searchCities;
	vm.getResultSearchCities = CityComponent.getResultSearchCities;
	vm.getGoingPaginationInfo = SubLineComponent.getGoingPaginationInfo;
	vm.getReturnPaginationInfo = SubLineComponent.getReturnPaginationInfo;
	vm.searchData = { 'ticket_type': 'one_way' };
	vm.onFocus = onFocus;
	vm.yesterdayDate = new Date();
	vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
	vm.selectFromCity = selectFromCity;
	vm.selectToCity = selectToCity;
	vm.choosenLine = choosenLine;
	vm.oneWayLine = {};
	vm.headerText = 'Lorem Ipsum dolor sit amet ';
	vm.selected = null;
	vm.goToChooseSeat = goToChooseSeat;
	vm.returnSubmit = false;
	vm.isSubmitActive = false;
	vm.disableContinueButton = false;

	$document.scrollToElement(publicPage, 0, 0);
	$rootScope.$on('$translateChangeSuccess', function () {
		var validForm = vm.searchData.from_city_id && vm.searchData.to_city_id && vm.searchData.date && $scope.searchSubLines && $scope.searchSubLines.$submitted;
		// Prevent service call ofrom another state
		if ($state.current.name === 'app.public.btms.home') {
			if (validForm) {
				vm.searchResult(vm.searchData, vm.dateReturn);
			}
		}
	});

	/** */
	function choosenLine(line, bus, direction) {

		vm.chooseError = false;
		var choosenItem = {
			'line_id': line.id,
			'bus_id': bus.id,
			'date': $filter('dateParser')(bus.departs_at, 'YYYY-MM-DD')
		};

		if (direction === 'going') {

			if (vm.oneWayLine.bus_id !== bus.id && vm.oneWayLine.date !== $filter('dateParser')(bus.departs_at, 'YYYY-MM-DD')) {
				vm.oneWayLine = choosenItem;

				// Set selected line and bus
				vm.selected = bus.id;
				vm.busDate = bus.departs_at;
				vm.lineId = line.line_id;

				return vm.oneWayLine;
			} else if (vm.oneWayLine.bus_id === vm.selected && vm.oneWayLine.date !== vm.busDate) {
				vm.oneWayLine = choosenItem;

				// Set selected line and bus
				vm.selected = bus.id;
				vm.busDate = bus.departs_at;
				vm.lineId = line.line_id;
			} else {

				vm.selected = null;
				vm.busDate = null;
				vm.oneWayLine = {};
			}
		} else if (direction === 'return') {
			if (vm.returnLine.date !== $filter('dateParser')(bus.departs_at, 'YYYY-MM-DD')) {
				vm.returnLine = choosenItem;

				// Set selected line and bus
				vm.returnSelected = bus.id;
				vm.returnDate = bus.departs_at;

				return vm.returnLine;
			} else {
				vm.returnSelected = null;
				vm.returnDate = null;
				vm.returnLine = {};
			}
		}
	}

	/**
  * Clears the results from the autocomplete search.
  */
	function clearResults() {
		CityComponent.clearResultSearchCities();
	}

	function onFocus(e) {
		// identify element by parent id ( http://stackoverflow.com/questions/25741050/get-id-of-parent-element-of-currently-clicked-element-in-angularjs )
		vm.autocompleteCity = e.target.parentNode.parentNode.id;
	}

	/** */
	function selectFromCity(city) {
		vm.queryFrom = city.translation.name;
		vm.searchData.from_city_id = city.id;
	}

	/** */
	function selectToCity(city) {
		vm.queryTo = city.translation.name;
		vm.searchData.to_city_id = city.id;
	}

	/**
  *  Exchange of cities(to city and from city)
  */
	function swapResult() {
		var cityTo = vm.queryTo;
		var cityFrom = vm.queryFrom;
		var cityToId = vm.searchData.to_city_id;
		var cityFromId = vm.searchData.from_city_id;

		vm.searchData.from_city_id = cityToId;
		vm.searchData.to_city_id = cityFromId;

		vm.queryTo = cityFrom;
		vm.queryFrom = cityTo;
	}

	/** */
	function searchResult(params, dateReturn) {
		params.is_public = true;
		vm.isSubmitActive = true;
		vm.returnSubmit = false;
		SubLineComponent.clearGoingSubLines();
		SubLineComponent.clearReturnSubLines();
		vm.goingBusId = '';
		vm.returnBusId = '';
		vm.subLineId = '';
		var hasErrors = false;
		// Clear error message and already choosen line
		vm.chooseError = false;
		// Clear selected line
		vm.oneWayLine = {};
		vm.returnLine = {};
		// Clear selected styles
		vm.busDate = '';
		vm.returnDate = '';

		angular.forEach($scope.searchSubLines.$error.required, function () {
			hasErrors = true;

			return false;
		});

		if (hasErrors) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));
			vm.isSubmitActive = false;

			return false;
		}

		if (!$scope.searchSubLines.$error.required) {
			hideRightPanel();
			$timeout(function () {
				SubLineComponent.searchSubLines(params, 'one_way').then(function (res) {
					if (res.data && res.data.errors) {
						Toast.responseError(res.data.errors);
					} else {
						if (params.ticket_type !== 'return') {
							showRightPanel();
							vm.dateReturn = null;
						}
						vm.goingSubLines = res;
						$document.scrollToElement(rightAside, 70, 1200);
					}
				});

				if (params.ticket_type === 'return') {
					var returnSubLineParams = JSON.parse(JSON.stringify(params));

					returnSubLineParams.from_city_id = params.to_city_id;
					returnSubLineParams.to_city_id = params.from_city_id;
					returnSubLineParams.date = dateReturn;

					SubLineComponent.searchSubLines(returnSubLineParams, 'return').then(function (res) {
						if (res.data && res.data.errors) {
							Toast.responseError(res.data.errors);
						} else {
							showRightPanel();
							vm.returnSubLines = res;
							vm.returnSubmit = true;
						}
					});
				}
			}, 500);
		}
	}

	/** */
	function hideRightPanel() {
		if (vm.goingSubLines) {
			rightAside.removeClass('slide-left');
			rightAside.addClass('slide-right');
			vm.selected = null;
		}
	}

	/** */
	function showRightPanel() {
		rightAside.addClass('slide-left');
		rightAside.removeClass('slide-right');
		$timeout(function () {
			vm.isSubmitActive = false;
		}, 700);
	}

	/** */
	function goToChooseSeat() {
		vm.disableContinueButton = true;
		if (vm.oneWayLine.line_id && !vm.returnSubLines) {
			$state.go('app.public.btms.choose-seat', { subLineId: vm.oneWayLine.line_id, busId: vm.oneWayLine.bus_id, date: vm.oneWayLine.date, returnId: vm.returnLine.line_id, returnBusId: vm.returnLine.bus_id, returnDate: vm.returnLine.date });
		} else if (vm.oneWayLine.line_id && vm.returnLine.line_id) {
			$state.go('app.public.btms.choose-seat', { subLineId: vm.oneWayLine.line_id, busId: vm.oneWayLine.bus_id, date: vm.oneWayLine.date, returnId: vm.returnLine.line_id, returnBusId: vm.returnLine.bus_id, returnDate: vm.returnLine.date });
		} else {
			Toast.error($filter('translate')('ERRORS.NO_SELECTED_BUS'));
			vm.chooseError = true;
			vm.disableContinueButton = false;
		}
	}
}

exports['default'] = HomeController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/main/home/home.controller.js
 **/